import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { clearFilters } from '../../../../redux/designerReducers/itemsReducer'
import { ReactComponent as FilterIcon } from '../../../../assets/filterdelete.svg'
import { setSelectedBubble } from '../../../../redux/designerReducers/canvasReducer'

const PillContainer = styled.div`
  position: relative;
  background: white;
  color: #ff5e6d;
  border: 1px solid #ff5e6d;
  box-sizing: border-box;
  border-radius: 34px;
  font-size: 11px;
  cursor: pointer;
  outline: none;
  user-select: none;
  color: white;
  background: #ff5e6d;
  margin-right: 8px;
  margin-bottom: 3px;
`

const Container = styled.div`
  height: 30px;
  padding-left: 7px;
  padding-right: 7px;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
  font-size: 11px;
  cursor: pointer;
  outline: none;
`

const Title = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 12px;
`

const IconContainer = styled.div`
  flex: 0 0 8px;
`

const Filter = styled(FilterIcon)`
  fill: white;
`

export const Pill = ({ data, onPillClick, onClick }) => {
  const handleClick = e => {
    if (onClick) onClick(data)
  }

  const handlePillClick = e => {
    if (onPillClick) onPillClick(data)
  }

  return (
    <PillContainer>
      <Container>
        <Title onClick={handlePillClick}>{data.label}</Title>
        <IconContainer onClick={handleClick}>
          <Filter />
        </IconContainer>
      </Container>
    </PillContainer>
  )
}

const FilterPills = ({ onPillClick, onClick, onAllPillClear, filters }) => {
  const dispatch = useDispatch()
  //const { filters } = useSelector(state => state.items)

  const handleClear = e => {
    if (onAllPillClear) onAllPillClear()
    else dispatch(clearFilters())

    dispatch(setSelectedBubble(null))
  }
  // onClick={handleClear}
  return (
    <>
      <Pill
        key={'clear'}
        data={{ type: 'clear', value: 'clear', label: 'Clear All' }}
        onClick={handleClear}
      />
      {filters.map(data => {
        return (
          <Pill
            key={data.value}
            data={data}
            onPillClick={onPillClick}
            onClick={onClick}
          />
        )
      })}
    </>
  )
}

export default FilterPills
